import React from "react";
import PropTypes from "prop-types";
import { Col } from "reactstrap";
import { useHistory } from "react-router-dom";
import { getImgDivClassName } from "../../../utils/style-helper";
import networkItemType from "../../../prop-types/networkItem";

const propTypes = {
  idx: PropTypes.number.isRequired,
  networkClient: networkItemType.isRequired
};

function NetworkCard(props) {
  const {
    idx,
    networkClient: { clientName, clientShortName, logo }
  } = props;

  const history = useHistory();

  const networkCardClick = () => history.push(`/${clientShortName}`);

  const handleKeyDown = (e) => {
    if ((e.type === "keydown" && e.keyCode === 13) || e.type === "click") {
      networkCardClick();
    }
  };

  return (
    <Col
      xs={12}
      sm={6}
      md={2}
      className="justify-content-center p-1 d-flex align-items-center network-card-container"
      tabIndex={idx}
      onKeyDown={handleKeyDown}
    >
      <div
        className={getImgDivClassName()}
        role="presentation"
        onClick={networkCardClick}
      >
        <img className="client-logo w-100" src={logo} alt={clientName} />
        <span className="text-center mt-3">{clientName}</span>
      </div>
    </Col>
  );
}

NetworkCard.propTypes = propTypes;

export default NetworkCard;
